import { Button } from 'antd'
import { useRouter } from 'next/router'
import { FunctionComponent } from 'react'
import styled from 'styled-components'
import { BasicModal } from '@/components/common/antd/basic-modal'
import { StyleParagraph } from '@/components/common/typography'
import { useIntl } from '@/i18n/hooks/use-intl'
import { reduxAPI } from '@/store/redux-api'

export const NeedReloadModal: FunctionComponent = () => {
  const router = useRouter()

  const { formatMessage } = useIntl()
  const needReloadModal = reduxAPI.state.modal.hooks.useVisible('needReload')

  const handleCancel: VoidFunction = () => {
    needReloadModal.toggleVisible()
  }

  const handleConfirm: VoidFunction = () => {
    router.reload()
  }

  return (
    <ModalWrapper
      footer={null}
      okButtonProps={{ style: { display: 'none' } }}
      open={needReloadModal.visible}
      title={formatMessage({ id: 'need_reload_modal:title' })}
      width={520}
      onCancel={handleCancel}
      onOk={handleConfirm}
    >
      <StyleParagraph>
        {formatMessage({ id: 'need_reload_modal:description' })}
      </StyleParagraph>

      <ButtonWrapper>
        <Button type='primary' onClick={handleConfirm}>
          {formatMessage({ id: 'need_reload_modal:button_text' })}
        </Button>
      </ButtonWrapper>
    </ModalWrapper>
  )
}

const ModalWrapper = styled(BasicModal)`
  text-align: center;
`

const ButtonWrapper = styled.div`
  margin: 30px 0 15px;
`
